import type { PatientStatus } from "@/server/types/patient-status";

/** How one lifecycle state reads in the UI. */
export type StatusPresentation = {
  label: string;
  /** Tailwind classes for the dot. Text stays foreground so the label is always legible. */
  dot: string;
};

/**
 * Display labels for the six lifecycle states. `added` reads as "Not invited"
 * because that is the action it implies, and `ready` reads as "Connected"
 * because a person scanning the table cares that records are arriving, not
 * which internal state produced them.
 */
export const PATIENT_STATUS_PRESENTATION: Record<PatientStatus, StatusPresentation> = {
  added: { label: "Not invited", dot: "bg-muted-foreground/50" },
  invited: { label: "Invited", dot: "bg-muted-foreground/50" },
  opened: { label: "Link opened", dot: "bg-muted-foreground/50" },
  connected: { label: "Connected", dot: "bg-emerald-500" },
  syncing: { label: "Syncing", dot: "bg-blue-500" },
  ready: { label: "Connected", dot: "bg-emerald-500" },
};

/** The attention overlay, which outranks the lifecycle state wherever both apply. */
export const NEEDS_ATTENTION_PRESENTATION: StatusPresentation = {
  label: "Needs attention",
  dot: "bg-amber-500",
};
